import HttpApi from './HttpApi';

// LEGACY CODE
export class Oauth extends HttpApi {
  logout () {
    return this.http.post('/api/logout');
  }
}

export default new Oauth('', '');